import { MsalService } from "@azure/msal-angular";
import { tap, concatMap, of } from "rxjs";
import { AppService } from "./app/service/app.service";
import { EntiService } from "./app/pages/anagrafica-ente/enti.service";

export function app_init(msalService: MsalService, appService: AppService, entiService: EntiService) {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {
      msalService.handleRedirectObservable().pipe(
        tap((response) => console.log("response from handle: ", response)),
        concatMap((response) => {
          if (!response && msalService.instance.getAllAccounts().length === 0) {
            msalService.loginRedirect();
            return of(false)
          }
          return appService.get();
        }),
        tap((user: any) => {
          if (user) {
            appService.user = user;
          }
        }),
        concatMap((user) => {
          if (user?.isUtenteAbilitato && user?.idEnte) {
            return entiService.get();
          }
          return of(user)
        }),
        tap((result) => {
          if (result && !result.isUtenteAbilitato) {
            appService.ente = result;
          }
        })
      ).toPromise().then((e) => {
          if (e) {
            resolve(true);
          }
        })
    })
  }
};
